// src/components/common/TooltipWrapper.js
import { useState, useEffect } from 'react';
import { StatefulTooltip, PLACEMENT } from 'baseui/tooltip';

const TooltipWrapper = ({ tooltipContent, children }) => {
    const [isTouchDevice, setIsTouchDevice] = useState(false);

    useEffect(() => {
        setIsTouchDevice(window.matchMedia('(pointer: coarse)').matches);
    }, []);

    if (isTouchDevice) {
        return children;
    }
    return (
        <StatefulTooltip content={tooltipContent} placement={PLACEMENT.bottom}>
            {children}
        </StatefulTooltip>
    );
};

export default TooltipWrapper;